import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { Media } from "../../../../Media/Media";
import { MediaImage, MediaProps } from "../../../../Media/Media.types";
import { Stack, StackItem } from "../../../../Stacks/Stack/Stack";

export interface ListItemMediaProps extends OmitStrict<MediaProps, "image"> {
    /**
     * If included, renders a colored square at the beginning of the list item
     * to associate the list item with another element on the page
     */
    readonly indicatorColor?: string;

    /** If `undefined`, renders just the `children` of `Media` */
    readonly image?: MediaImage;
}

export const ListItemMedia: React.FC<ListItemMediaProps> = ({
    children,
    indicatorColor,
    image,
    disabled = false,
    padding,
    height,
    ...mediaProps
}) => {
    const media = !image ? (
        <Stack>{children}</Stack>
    ) : (
        <Media {...mediaProps} padding={padding || "0px"} height={height || "auto"} image={image}>
            <Stack padding="0px 0px 0px 12px">
                {!disabled ? children : React.Children.map(children, (child, index) => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, { disabled, key: child.key || index });
                    }
                    return child;
                })}
            </Stack>
        </Media>
    );

    return !indicatorColor ? media : (
        <Stack horizontal={true} verticalAlign="center" childrenGap={16}>
            <StackItem>
                <div role="presentation" style={{ backgroundColor: indicatorColor, borderRadius: 2, width: 12, height: 12 }} />
            </StackItem>
            {media}
        </Stack>
    );
};
